import { render, staticRenderFns } from "./techTalentManager.vue?vue&type=template&id=1a316f24"
import script from "./techTalentManager.vue?vue&type=script&lang=js"
export * from "./techTalentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports